document.querySelectorAll('store-header').forEach((header) => {
  header.addEventListener('mouseenter', () => {
    header.querySelectorAll('.mega-menu__image-wrapper img').forEach((img) => {
      const dataSrc = img.getAttribute('data-src');

      if (dataSrc && !img.getAttribute('src')) {
        img.setAttribute('src', dataSrc);
      }

      const dataSrcset = img.getAttribute('data-srcset');

      if (dataSrcset && !img.getAttribute('srcset')) {
        img.setAttribute('srcset', dataSrcset);
      }
    });
  }, { once: true });
});
